(ns rlws.iot-cloud.frontend.fx
  (:require [re-frame.core :as rf]))

(rf/reg-fx
 ::console.log
 (fn [message]
   (js/console.log message)))

(defonce -intervals (atom {}))

(rf/reg-fx
 ::interval
 (fn [{:keys [action id frequency event]}]
   (case action
     :start
     (do
       (when-let [interval (get @-intervals id)]
         (js/clearInterval interval))
       (swap! -intervals assoc id (js/setInterval #(rf/dispatch event) frequency)))
     :stop
     (do (js/clearInterval (get @-intervals id))
         (swap! -intervals dissoc id))
     :stop-all
     (do
       (doseq [[_ interval] @-intervals]
         (js/clearInterval interval))
       (reset! -intervals {}))
     (js/console.error "Unknown action for interval"))))

(defonce debounced-state (atom {}))

(defn dispatch-debounced
  "Dispatch events debounced by `ms`"
  [{:keys [key event ms]}]
  (some-> (get @debounced-state key) js/clearTimeout)
  (let [timeout (js/setTimeout #(do
                                  (rf/dispatch event)
                                  (swap! debounced-state dissoc key))
                               ms)]
    (swap! debounced-state assoc key timeout)))

(rf/reg-fx ::dispatch-debounced dispatch-debounced)
